import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_SGTEC_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterTodos(filtro) {
        return axiosJwt
            .get(
                `${api}/sgtec/financeiro/pagamentos?situacao=${filtro.situacao}&status=${filtro.status}&dataInicial=${filtro.dataInicial}&dataFinal=${filtro.dataFinal}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPorId(pagamentoId) {
        return axiosJwt
            .get(`${api}/sgtec/financeiro/pagamentos/${pagamentoId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPagamentoAnexo(pagamentoAnexoId) {
        return axiosJwt
            .get(`${api}/sgtec/financeiro/pagamentos/anexos/${pagamentoAnexoId}`, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterHistorico(pagamentoId) {
        return axiosJwt
            .get(`${api}/sgtec/financeiro/pagamentos/${pagamentoId}/historico`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTimeLine(pagamentoId) {
        return axiosJwt
            .get(`${api}/sgtec/financeiro/pagamentos/${pagamentoId}/timeline`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    // ************************* //
    // Notas Fiscais
    // ************************* //

    obterNotasFiscais(pagamentoId) {
        return axiosJwt
            .get(`${api}/sgtec/financeiro/pagamentos/${pagamentoId}/notasfiscais`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterNotaFiscal(pagamentoNotaFiscalId) {
        return axiosJwt
            .get(`${api}/sgtec/financeiro/pagamentos/notasfiscais/${pagamentoNotaFiscalId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    atualizarNotaFiscal(notaFiscal) {
        return axiosJwt
            .put(
                `${api}/sgtec/financeiro/pagamentos/${notaFiscal.pagamentoId}/notasfiscais/${notaFiscal.pagamentoNotaFiscalId}`,
                notaFiscal
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    downloadNotaFiscal(pagamentoNotaFiscalId) {
        return axiosJwt
            .get(`${api}/sgtec/financeiro/pagamentos/notasfiscais/${pagamentoNotaFiscalId}/baixar`, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    // ************************* //
    // Faturamento
    // ************************* //

    obterTiposMovimentoDestino(pagamentoId) {
        return axiosJwt
            .get(`${api}/sgtec/financeiro/pagamentos/${pagamentoId}/tiposmovimentodestino`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    faturarPagamento(pagamentoId, tipoMovimentoDestino) {
        return axiosJwt
            .post(`${api}/sgtec/financeiro/pagamentos/${pagamentoId}/faturar`, {
                pagamentoId,
                tipoMovimentoDestino
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
